import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { OPERATING_AREA_SUGGESTIONS } from '../data/operatingAreas';

const MAX = 10;

function OperatingAreasInput({ value = [], onChange, disabled = false }) {
  const [text, setText] = useState('');
  const [showList, setShowList] = useState(false);

  const add = (name) => {
    const clean = (name || '').trim();
    if (!clean) return;
    if (value.some((v) => v.toLowerCase() === clean.toLowerCase())) { setText(''); setShowList(false); return; }
    if (value.length >= MAX) { setText(''); setShowList(false); return; }
    onChange([...value, clean]);
    setText('');
    setShowList(false);
  };

  const remove = (name) => onChange(value.filter((v) => v !== name));

  const filtered = text
    ? OPERATING_AREA_SUGGESTIONS.filter((s) => s.toLowerCase().includes(text.toLowerCase())).slice(0, 8)
    : OPERATING_AREA_SUGGESTIONS.slice(0, 8);

  return (
    <div>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-2">
          {value.map((v) => (
            <span
              key={v}
              className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700"
            >
              {v}
              {!disabled && (
                <button type="button" onClick={() => remove(v)} className="text-green-600 hover:text-green-800" title="Remove">
                  <FaTimes size={10} />
                </button>
              )}
            </span>
          ))}
        </div>
      )}

      {!disabled && (
        <div className="relative">
          <input
            type="text"
            value={text}
            onChange={(e) => { setText(e.target.value); setShowList(true); }}
            onFocus={() => setShowList(true)}
            onBlur={() => setTimeout(() => setShowList(false), 150)}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(text); } }}
            placeholder={value.length >= MAX ? `Max ${MAX} areas reached` : 'Type a province or country, then Enter (e.g. Gauteng, Zimbabwe)'}
            disabled={value.length >= MAX}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-green"
          />
          {showList && filtered.length > 0 && (
            <div className="absolute z-10 w-full bg-white rounded-lg shadow-lg border mt-1 max-h-48 overflow-y-auto" style={{ borderColor: '#E8ECEF' }}>
              {filtered.map((s) => (
                <button
                  key={s}
                  type="button"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => add(s)}
                  className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors border-b last:border-b-0"
                  style={{ borderColor: '#E8ECEF' }}
                >
                  {s}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default OperatingAreasInput;
